module.exports = __webpack_public_path__ + "img/android-red.6c902a8.svg";